import { render, staticRenderFns } from "./VisitsPurpose.vue?vue&type=template&id=4c268e1d&"
import script from "./VisitsPurpose.vue?vue&type=script&lang=js&"
export * from "./VisitsPurpose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports